import axios, { AxiosInstance } from "axios"
import * as qs from "qs"

import { HttpBase } from "../http/http-base"

export class Http extends HttpBase {
  get http(): AxiosInstance {
    const http = axios.create({
      baseURL: [this.host, ".netlify/functions"].join("/"),
      headers: this.headers,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "brackets" })
      },
    })

    return http
  }
}
